import Vue from "vue"
import Vuex from "vuex"

import actions from "./actions"
import getters from "./getters"
import control from "./modules/control/common"

Vue.use(Vuex);

export default new Vuex.Store({
    actions,
    getters,
    modules: {
      control
    }
})




// WEBPACK FOOTER //
// ./src/store/index.js